import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Dropdown, Avatar, message } from 'antd';
import { UserOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

export default function ProfileMenu() {
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();
  const { signOut, session } = useAuth();

  // Check if the screen is mobile size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      setLoading(true);
      await signOut();
      message.success('U bent succesvol uitgelogd');
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error during logout:', error);
      message.error('Er is een fout opgetreden tijdens het uitloggen');
    } finally {
      setLoading(false);
    }
  };

  // Get initials from email or company name
  const getInitials = (): string => {
    const email = session?.user?.email || '';
    const voornaam = session?.user?.user_metadata?.voornaam || '';
    const achternaam = session?.user?.user_metadata?.achternaam || '';
    
    if (voornaam && achternaam) {
      return `${voornaam[0]}${achternaam[0]}`.toUpperCase();
    }
    return email.substring(0, 2).toUpperCase();
  };

  const items = [
    {
      key: 'profile',
      label: <Link to="/profile">Profiel instellingen</Link>,
      icon: <SettingOutlined />,
    },
    {
      key: 'logout',
      label: 'Uitloggen',
      icon: <LogoutOutlined />,
      disabled: loading,
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Avatar
        style={{
          backgroundColor: '#1890ff',
          cursor: 'pointer',
          fontSize: isMobile ? '12px' : '14px',
          width: isMobile ? '28px' : '32px',
          height: isMobile ? '28px' : '32px',
        }}
        icon={getInitials() || <UserOutlined />}
      />
    </Dropdown>
  );
}
